import React, { useEffect, useRef, useState } from "react";
import { FaArrowUp, FaBars, FaMoon, FaSun, FaTimes } from "react-icons/fa";

const Header = ({ theme, onThemeChange }) => {
  const [open, setOpen] = useState(false);
  const progressRef = useRef(null);

  useEffect(() => {
    let frame = 0;

    const update = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        const progress =
          window.scrollY /
          Math.max(
            1,
            document.documentElement.scrollHeight - window.innerHeight,
          );
        progressRef.current?.style.setProperty(
          "--scroll-progress",
          String(Math.min(1, Math.max(0, progress))),
        );
        frame = 0;
      });
    };

    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => {
      window.removeEventListener("scroll", update);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);
  const navItems = [
    ["Profile", "about"],
    ["Project", "portfolio"],
    ["Experience", "experience"],
    ["Journey", "activity"],
    ["Contact", "contact"],
  ];
  const goTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };
  return (
    <header className="site-header is-floating">
      <div className="progress-track" ref={progressRef}>
        <div className="reading-progress" />
      </div>
      <div className="site-container header-inner">
        <button className="brand" onClick={() => goTo("home")}>
          <span className="brand-mark">
            <img
              src={`${process.env.PUBLIC_URL}/chaoscreatoricon.png`}
              alt=""
            />
          </span>
          <span className="brand-title">
            Chaos<em>Creator</em>
          </span>
        </button>
        <nav className={`nav-links ${open ? "open" : ""}`}>
          {navItems.map(([label, id]) => (
            <button key={id} onClick={() => goTo(id)}>
              {label}
            </button>
          ))}
        </nav>
        <div className="header-actions">
          <button
            className="theme-button"
            onClick={onThemeChange}
            aria-label="Toggle colour theme"
          >
            {theme === "dark" ? <FaSun /> : <FaMoon />}
          </button>
          <button
            className="menu-button"
            onClick={() => setOpen(!open)}
            aria-label="Open navigation"
          >
            {open ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>
      <button
        className="to-top"
        onClick={() => goTo("home")}
        aria-label="Back to top"
      >
        <FaArrowUp />
      </button>
    </header>
  );
};
export default Header;
